import { useState } from 'react';
import { FiHelpCircle } from 'react-icons/fi';
import HelpPanel from './HelpPanel';
import type { HelpTopicKey } from '../../../../types/LegalCase';

interface HelpButtonProps {
    topic: HelpTopicKey;
    // Quando o botão vive dentro de um modal (Dialog em z-50), o drawer precisa subir uma camada.
    elevated?: boolean;
    label?: string;
}

// Ícone de ajuda que abre o HelpPanel do tópico. Deliberadamente FiHelpCircle, não o FaInfoCircle
// que no ClaimChargesCard já significa "tooltip de uma linha" — usar o mesmo ícone ensinaria o
// usuário a esperar tooltip e receber drawer.
export const HelpButton = ({ topic, elevated = false, label = 'Abrir ajuda desta seção' }: HelpButtonProps) => {
    const [open, setOpen] = useState(false);

    return (
        <>
            <button
                type="button"
                onClick={() => setOpen(true)}
                aria-label={label}
                title="Ajuda"
                className="p-1 text-gray-400 dark:text-gray-500 hover:text-blue-600 dark:hover:text-blue-400 hover:bg-gray-100 dark:hover:bg-slate-700 rounded"
            >
                <FiHelpCircle size={14} />
            </button>
            <HelpPanel open={open} topic={topic} elevated={elevated} onClose={() => setOpen(false)} />
        </>
    );
};

interface SectionHelpTitleProps {
    title: string;
    topic: HelpTopicKey;
    elevated?: boolean;
}

// Título de seção uppercase (o mesmo `<h4>` que se repete nas telas do recovery) com o botão de
// ajuda ao lado. Um componente, não cinco integrações à mão — os pontos de ancoragem usam todos
// a mesma classe de título.
export const SectionHelpTitle = ({ title, topic, elevated = false }: SectionHelpTitleProps) => (
    <div className="flex items-center gap-1.5">
        <h4 className="text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">{title}</h4>
        <HelpButton topic={topic} elevated={elevated} label={`Abrir ajuda: ${title}`} />
    </div>
);
